<template>
  <div>
    <InventoryHead
            :countFilterParams="countFilterParams"
            :showFilter="showFilter"
            @toggleFilter="toggleFilter"
            @filter="$emit('filter')"
            @reload="$emit('reload')"
    />

    <div class="table-filter-wrap">
      <InventoryFilter
              :showFilter="showFilter"
              :filterGetParams="filterGetParams"
              @close="closeFilter"
              @changeFilter="data => $emit('changeFilter', data)"
              @resetFilter="$emit('resetFilter')"
      />

      <InventoryTable
              @showMore="$emit('showMore')"
              @resetFilter="$emit('resetFilter')"
              @updateTable="$emit('updateTable')"
              @reload="$emit('reload')"
      />
    </div>
  </div>
</template>

<script>


  import InventoryHead from "./InventoryHead/InventoryHead";
  import InventoryFilter from "./InventoryFilter/InventoryFilter";
  import InventoryTable from "./InventoryTable/InventoryTable";

  export default {
    name: "InventoryTableBlock",

    components: {
      InventoryHead,
      InventoryFilter,
      InventoryTable,
    },

    props: {
      countFilterParams: Number,
      filterGetParams: Object,
    },

    data(){
      return{
        showFilter: false,
      }
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },
    }
  }
</script>

<style scoped>

</style>
